export const Show = ({ when, children }: { when: boolean; children: any }) =>
  when ? children : null
